<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="所在项目：" prop="top_pid">
                <span>{{ transEnu(model.top_pid, "project_group") }}</span>
            </el-form-item>
            <el-form-item label="设备类型：" prop="device_type">
                <span>{{ transEnu(model.device_type, "device_type4") }}</span>
            </el-form-item>
            <el-form-item label="设备编号：" prop="device_code">
                <span>{{model.device_code}}</span>
            </el-form-item>
            <el-form-item label="设备名称：" prop="device_name">
                <span>{{model.device_name}}</span>
            </el-form-item>
            <el-form-item label="日期：" prop="day">
                <span>{{model.day}}</span>
            </el-form-item>
            <el-form-item label="是否巡检：" prop="is_check">
                <span>{{ transEnu(model.is_check, "yesNo") }}</span>
            </el-form-item>
            <el-form-item label="巡检结果：" prop="answers" v-if="model.is_check==1">
                <div v-for="(item, idx) in questions" :key="item.sort">
                    {{item.title}} ：{{answers[idx]==0?"否":"是"}}
                </div>
            </el-form-item>
            <el-form-item label="其他问题：" prop="other_question" v-if="model.is_check==1">
                <span>{{model.other_question}}</span>
            </el-form-item>
            <el-form-item label="照片：" prop="pictures" v-if="model.is_check==1">
                <div class="imgsBox" v-for="img in img_list" :key="img">
                    <el-image style="width: 160px; height: 160px" :src="img" :preview-src-list="img_list"></el-image>
                </div>
            </el-form-item>
            <el-form-item label="经度：" prop="lng" v-if="model.is_check==1">
                <span>{{model.lng}}</span>
            </el-form-item>
            <el-form-item label="维度：" prop="lat" v-if="model.is_check==1">
                <span>{{model.lat}}</span>
            </el-form-item>
            <el-form-item label="巡检时间：" prop="add_time" v-if="model.is_check==1">
                <span>{{model.check_time}}</span>
            </el-form-item>
            <el-form-item label="上传时间：" prop="add_time" v-if="model.is_check==1">
                <span>{{model.add_time}}</span>
            </el-form-item>
            <el-form-item label="巡检人：" prop="creator_name" v-if="model.is_check==1">
                <span>{{model.creator_name}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { getModelById } from '@/api/common'

export default {
    name: 'deviceInspectionLogInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                top_pid: '',
                report_id: '',
                device_type: '',
                device_id: '',
                device_code: '',
                device_name: '',
                day: '',
                answers: '',
                other_question: '',
                pictures: '',
                is_check: '',
                lng: '',
                lat: '',
                add_time: '',
                creator_id: '',
                creator_name: '',
            },
            getObj:{
                url:'/api/admin/deviceinspectionlog/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['device_type4', 'project_group', 'yesNo'],
            questions: [],
            answers: [],
            img_list: [],
        };
    },
    methods: {
        loadOtherData(){
            if(this.id <= 0){
                this.questions = []
                this.img_list = []
                this.answers = []
            }
        },
        getModelData() {
            this.model = this.copyObj(this.init_model);
            if (this.id > 0) {
                this.getObj.data.value = this.id;
                getModelById(this.getObj).then(res => {
                    if (res.code === 1) {
                        this.model = res.data.obj;
                        this.questions = res.data.question
                        this.answers = res.data.an
                        this.img_list = res.data.pictures
                        this.formateData();
                    } else {
                        this.$msg(res.msg)
                        this.closeDialog()
                    }
                })
            }
        },
        formateData(){
            
        },
    }
};
</script>
<style lang="less" scoped>
    .imgsBox {
        width: 160px;
        height: 160px;
        position: relative;
        display: inline-block;
        margin-right: 10px;
        margin-bottom: 10px;
    }
</style>